__webpack_require__.hmrF = () => ("dev-integrations-panel." + __webpack_require__.h() + ".hot-update.json");